var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('gat-tab',{attrs:{"items":_setup.tabs,"show-in-toolbar":true}}),_c('keep-alive',[_c('router-view',{attrs:{"callId":"","location":"proforma","proformaId":+_setup.props.proformaId,"parentId":+_setup.props.proformaId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }